export default class GetPersonalByLoc {
  #repository
  constructor(repository) {
    this.#repository = repository
  }

  async execute(idLoc) {
    try {
      const result = await this.#repository.getPersonalByLoc(idLoc)
      return result
    } catch (error) {
      console.log(error)
      throw error
    }
  }
}
